import { faCalendarAlt, faKey } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Tab, Tabs } from "react-bootstrap";
import GestaoVistoriaEntregaChaves from "../GestaoVistoriaEntregaChaves";
import AgendamentoCorte from "../AgendamentoCorte";

function GestaoVistoriaTabs() {
    return (
        <>
            <Tabs>
                <Tab
                    title={
                        <>
                            <FontAwesomeIcon className="mr-2" icon={faKey} />
                            {"Gestão de Vistoria Entrega de Chaves"}
                        </>
                    }
                    eventKey={"GestaoVistoriaEntregaChaves"}
                >
                    <GestaoVistoriaEntregaChaves />
                </Tab>
                <Tab
                    title={
                        <>
                            <FontAwesomeIcon
                                className="mr-2"
                                icon={faCalendarAlt}
                            />
                            {"Agendamento de Corte"}
                        </>
                    }
                    eventKey={"AgendamentoCorte"}
                >
                    <AgendamentoCorte />
                </Tab>
            </Tabs>
        </>
    );
}

export default GestaoVistoriaTabs;
